import { fitBoundsToRegion } from '@/utils/map';
import { getMapRegionFromSearch } from '@/utils/map-region';
import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';
import { useEffect, useRef } from 'react';
import { convertBoundsToRestriction } from '../utils/bounds';
import { useCruiseWithRoute } from './use-cruise';

export function useBounds() {
  const map = useMap();
  const geometryLibrary = useMapsLibrary('geometry');
  const data = useCruiseWithRoute();
  const initialRegionRef = useRef(getMapRegionFromSearch());
  const hasAppliedInitialRegionRef = useRef(false);
  const initialRegion = initialRegionRef.current;

  useEffect(() => {
    if (!map || !geometryLibrary) {
      return;
    }

    const extent = new google.maps.LatLngBounds();
    for (const day of data?.cruise?.days ?? []) {
      if (day.port.position) {
        extent.extend({ lng: day.port.position[0], lat: day.port.position[1] });
      }
    }

    for (const feature of data?.paths?.features ?? []) {
      for (const position of feature.geometry.coordinates) {
        extent.extend({ lng: position[0], lat: position[1] });
      }
    }

    if (!extent.isEmpty()) {
      if (initialRegion && !hasAppliedInitialRegionRef.current) {
        fitBoundsToRegion(map, initialRegion);
        hasAppliedInitialRegionRef.current = true;
      } else if (!hasAppliedInitialRegionRef.current) {
        map.fitBounds(extent, 60);
      }
    } else if (initialRegion && !hasAppliedInitialRegionRef.current) {
      fitBoundsToRegion(map, initialRegion);
      hasAppliedInitialRegionRef.current = true;
    }

    map.setOptions({
      restriction: convertBoundsToRestriction(extent, geometryLibrary),
    });
  }, [map, geometryLibrary, data, initialRegion]);
}
